import { NgModule, APP_INITIALIZER } from '@angular/core';
import { StpApiClientModule } from './api-client/api-client.module';
import { StpCommonModule } from './common/common.module';
import { AppConfigurationService, appConfigurationServiceFactory } from './common';
import { StpFormsModule } from './forms/forms.module';

@NgModule({
  imports: [
    StpCommonModule,
    StpApiClientModule,
    StpFormsModule
  ],
  exports: [
    StpCommonModule,
    StpApiClientModule,
    StpFormsModule
  ],
  declarations: [],
  providers: [
    {
      provide: APP_INITIALIZER,
      useFactory: appConfigurationServiceFactory,
      deps: [AppConfigurationService],
      multi: true
    }
  ],
})
export class StpAppModule { }
